import moment from 'moment';
import { initialize } from 'redux-form';
import { calculateHostCancellation, cancellationGuestData, getPriceWithDiscount } from '../../helpers/cancellationData';
import { getDateRanges } from '../../helpers/dateRange';
import getCancellationData from '../../routes/siteadmin/cancellation/getCancellationData.graphql';
import { cancellationRule, typeCheck } from '../../helpers/cancellationCheck';

export default function GuestCancellationData(id, userType) {
  return async (dispatch, getState, { client }) => {
    try {
      let subtotal = 0, isCleaingPrice = 0, taxPrice = 0, totalNights = 0, priceForDays = 0, totalPrice = 0, finalPrice = 0, refundableNightPrice = 0, nonRefundableNightPrice = 0, updatedGuestFee = 0, updatedHostFee = 0, payoutToHost = 0;
      let bookingSpecialPricing = [], isSpecialPriceAssigned = false, cancellationGuestObj = {}, accomodation, guestFees, remainingNights, policyName, policyContent, priorDays, cancellation;
      let serviceFees = getState()?.book?.serviceFees, base = getState()?.currency?.base, rates = getState()?.currency?.rates, nonRefundableNights, type = 'priorCheckIn';

      const { data } = await client.query({
        query: getCancellationData,
        variables: { id: Number(id)},
        fetchPolicy: 'network-only'
      });

      if (data?.getCancellationData?.result != undefined || data?.getCancellationData?.result != null) {
        const { nights, interval } = getDateRanges({ checkIn: data?.getCancellationData?.result?.checkIn, checkOut: data?.getCancellationData?.result?.checkOut, country: data?.getCancellationData?.result?.listData?.country });
        cancellation = data?.getCancellationData?.result?.cancellation ? data?.getCancellationData?.result?.cancellation : data?.getCancellationData?.result?.listingData?.cancellation;
        let cancellationRuleObj = { accomodation, guestFees, nonRefundableNights, priorDays, policyName, remainingNights, interval, nights, policyContent },isTaxRefunded;

        //helper to check the type
        type = typeCheck(interval, cancellation);

        //helper to get the cancellation rule
        cancellationRuleObj = cancellationRule(type, cancellationRuleObj, cancellation);
        cancellationRuleObj['interval'] = interval;
        cancellationRuleObj['nights'] = nights;

        if (type == 'priorCheckIn' || type == 'beforeCheckIn') {
          cancellationRuleObj['cleaningFeePercent'] = type == 'beforeCheckIn' && cancellation.id === 3 ? 0 : 100;
          cancellationRuleObj['taxFeePercent'] = type == 'beforeCheckIn' && cancellation.id === 3 ? 0 : 100;
          isTaxRefunded = true
          if (type == 'priorCheckIn') {
            cancellationRuleObj['cleaningFeePercent'] = 100;
            cancellationRuleObj['taxFeePercent'] = 100;
          }
        } else {
          cancellationRuleObj['remainingNights'] = (nights - 1) + interval;
          cancellationRuleObj['cleaningFeePercent'] = 0;
          cancellationRuleObj['taxFeePercent'] = 0;
          isTaxRefunded = false
        }

        if (data?.getCancellationData?.result?.cleaningPrice) {
          isCleaingPrice = data?.getCancellationData?.result?.cleaningPrice;
        } else {
          isCleaingPrice = 0;
        }

        if (data?.getCancellationData?.result?.taxPrice) {
          taxPrice = data?.getCancellationData?.result?.taxPrice;
        } else {
          taxPrice = 0;
        }

        data?.getCancellationData?.result?.bookingSpecialPricing.map((item, key) => {
          let currentPrice;
          if (item?.blockedDates) {
            isSpecialPriceAssigned = true;
            currentPrice = Number(item?.isSpecialPrice);
          } else {
            currentPrice = Number(data?.getCancellationData?.result?.basePrice);
          }
          bookingSpecialPricing.push({
            blockedDates: item,
            isSpecialPrice: currentPrice,
          });
        })

        if (userType == 'host') {
          if (isSpecialPriceAssigned) bookingSpecialPricing?.map((item, index) => {
            priceForDays = Number(priceForDays) + Number(item?.isSpecialPrice);
          });
          else priceForDays = Number(data?.getCancellationData?.result?.basePrice) * Number(cancellationRuleObj?.nights - cancellationRuleObj?.nonRefundableNights);

          totalPrice = getPriceWithDiscount({
            basePrice: (data?.getCancellationData?.result?.isSpecialPriceAverage || data?.getCancellationData?.result?.basePrice),
            discount: data?.getCancellationData?.discount,
            nights: cancellationRuleObj?.nights
          });

          const { refundAmount, nonPayoutAmount, payoutAmount, refundDays, updatedHostFee, updatedGuestFee } = calculateHostCancellation({
            total: data?.getCancellationData?.result?.total,
            basePrice: totalPrice,
            isCleaingPrice,
            nights: cancellationRuleObj?.nights,
            remainingNights: cancellationRuleObj?.remainingNights,
            guestServiceFee: data?.getCancellationData?.result?.guestServiceFee,
            hostServiceFee: data?.getCancellationData?.result?.hostServiceFee,
            taxPrice,
            hostServiceFeeType: data?.getCancellationData?.result?.hostServiceFeeType,
            hostServiceFeeValue: data?.getCancellationData?.result?.hostServiceFeeValue,
            interval: cancellationRuleObj?.interval
          })

          subtotal = data?.getCancellationData?.result?.total + data?.getCancellationData?.result?.guestServiceFee;
          totalNights = nights - refundDays;

          let cancellationData = {
            reservationId: data?.getCancellationData?.result?.id,
            cancellationPolicy: cancellationRuleObj?.policyName,
            refundToGuest: refundAmount,
            payoutToHost: payoutAmount,
            guestServiceFee: updatedGuestFee,
            hostServiceFee: updatedHostFee,
            total: subtotal,
            currency: data?.getCancellationData?.result?.currency,
            threadId: data?.getCancellationData?.result?.messageThreadId?.id,
            cancelledBy: 'host',
            checkIn: moment(data?.getCancellationData?.result?.checkIn).format("YYYY-MM-DD"),
            checkOut: moment(data?.getCancellationData?.result?.checkOut).format("YYYY-MM-DD"),
            guests: data?.getCancellationData?.result?.guests,
            hostName: data?.getCancellationData?.result?.hostData?.firstName,
            guestName: data?.getCancellationData?.result?.guestData?.firstName,
            listTitle: data?.getCancellationData?.result?.listData.title,
            confirmationCode: data?.getCancellationData?.result?.confirmationCode,
            guestEmail: data?.getCancellationData?.result?.guestData?.userData?.id,
            userType,
            totalPrice,
            refundDays,
            nonPayoutAmount,
            payoutAmount,
            totalNights,
            isTaxRefunded
          };
          dispatch(initialize('AdminCancellation', cancellationData));
        } else {
          finalPrice = getPriceWithDiscount({
            basePrice: (data?.getCancellationData?.result?.isSpecialPriceAverage || data?.getCancellationData?.result?.basePrice),
            discount: data?.getCancellationData?.result?.discount,
            nights: cancellationRuleObj?.nights
          });

          if (isSpecialPriceAssigned) {
            bookingSpecialPricing.map((item, index) => {
              priceForDays = Number(priceForDays) + Number(item?.isSpecialPrice);
            });
          } else if (userType == 'guest') {
            if (interval <= 1) priceForDays = Number(data?.getCancellationData?.result?.basePrice) * Number(cancellationRuleObj?.nights - cancellationRuleObj?.nonRefundableNights)
            else priceForDays = Number(data?.getCancellationData?.result?.basePrice) * Number(cancellationRuleObj?.nights)
          }

          cancellationGuestObj = cancellationGuestData(
            cancellationRuleObj?.remainingNights,
            cancellationRuleObj?.nights,
            priceForDays,
            cancellationRuleObj?.accomodation,
            isCleaingPrice,
            data?.getCancellationData?.result?.taxRate,
            data?.getCancellationData?.result?.guestServiceFee,
            cancellationRuleObj?.guestFees,
            data?.getCancellationData?.result?.discount,
            data?.getCancellationData?.result?.hostServiceFee,
            taxPrice,
            finalPrice,
            data?.getCancellationData?.result?.total,
            cancellationRuleObj?.policyName,
            cancellationRuleObj?.interval,
            cancellationRuleObj?.priorDays,
            cancellationRuleObj?.nonRefundableNights,
            data?.getCancellationData?.result?.hostServiceFeeType,
            data?.getCancellationData?.result?.hostServiceFeeValue,
            data?.getCancellationData?.result?.currency,
            base,
            rates,
            serviceFees,
            cancellationRuleObj?.cleaningFeePercent,
            cancellationRuleObj?.taxFeePercent
          );

          refundableNightPrice = cancellationGuestObj?.refundableNightPrice;
          nonRefundableNightPrice = cancellationGuestObj?.nonRefundableNightPrice;
          updatedGuestFee = cancellationGuestObj?.updatedGuestFee;
          payoutToHost = cancellationGuestObj?.payoutToHost;
          updatedHostFee = cancellationGuestObj?.updatedHostFee;
          updatedGuestFee = cancellationGuestObj?.updatedGuestFee;
          subtotal = data?.getCancellationData?.result?.total + data?.getCancellationData?.result?.guestServiceFee;

          let cancellationData = {
            reservationId: data?.getCancellationData?.result?.id,
            cancellationPolicy: cancellationRuleObj?.policyName,
            refundToGuest: refundableNightPrice,
            payoutToHost: payoutToHost,
            guestServiceFee: updatedGuestFee,
            hostServiceFee: updatedHostFee,
            total: subtotal,
            currency: data?.getCancellationData?.result?.currency,
            threadId: data?.getCancellationData?.result?.messageThreadId?.id,
            cancelledBy: 'guest',
            checkIn: moment(data?.getCancellationData?.result?.checkIn).format("YYYY-MM-DD"),
            checkOut: moment(data?.getCancellationData?.result?.checkOut).format("YYYY-MM-DD"),
            guests: data?.getCancellationData?.result?.guests,
            guestName: data?.getCancellationData?.result?.guestData?.firstName,
            hostName: data?.getCancellationData?.result?.hostData?.firstName,
            listTitle: data?.getCancellationData?.result?.listData.title,
            confirmationCode: data?.getCancellationData?.result?.confirmationCode,
            hostEmail: data?.getCancellationData?.result?.hostData.userData.id,
            userType,
            nonRefundableToGuest: nonRefundableNightPrice,
            isTaxRefunded
          };
          dispatch(initialize('AdminCancellation', cancellationData));
        }
      }
    } catch (error) {
      console.log("Something went wrong", error)
    }
  }
}